import { ResourceType } from '@cotera/api';
import { resourceKind } from '@cotera/sdk/core';

export type ShareTarget = { type: ResourceType; id: string; name?: string };

export const shareTargetKey = (target: { type: ResourceType; id: string }) =>
  `${target.type}:${target.id}`;

/**
 * Types whose pages have a real read-only mode. The server enforces View on
 * every type, but a chat, agent, workflow or folder still renders its full
 * editor to a viewer and lets them try edits that fail — so View is only
 * offered where the page actually behaves like a viewer's page.
 */
const VIEW_READY_TYPES: ReadonlySet<ResourceType> = new Set([
  ResourceType.Document,
  ResourceType.Dataset,
]);

export const canOfferViewFor = (targets: readonly ShareTarget[]): boolean =>
  targets.length > 0 &&
  targets.every((target) => VIEW_READY_TYPES.has(target.type));

export const VIEW_UNAVAILABLE_HINT =
  'For now, only documents and datasets can be view-only.';

export const shareTargetLabel = (type: ResourceType): string =>
  resourceKind(type).label;

/** "this chat", "3 items" — for sentences about what is being shared. */
export const describeShareTargets = (
  targets: readonly ShareTarget[]
): string => {
  const [first] = targets;
  if (first === undefined) {
    return 'nothing';
  }
  if (targets.length === 1) {
    return `this ${shareTargetLabel(first.type).toLowerCase()}`;
  }
  return `${targets.length} items`;
};
